import { groupBy, isEmpty, uniqBy, values } from 'lodash';
import { getTranslationByKey } from './translation-helper';

function arraySequenceCheck(seqArr) {
  for (let index = 1; index < seqArr.length; index += 1) {
    if (seqArr[index] - seqArr[index - 1] > 1) {
      return false;
    }
  }
  return true;
}

function getSequenceChunks(arr, n) {
  let count = 0;
  let arr1 = [];
  while (count < arr.length) {
    const res = arr.slice(count, count + n);
    if (arraySequenceCheck(res)) {
      arr1.push(res);
      count = count + n;
    } else {
      count = count + 1;
    }
  }
  return arr1;
}

function venuesSimplify(venuesArr) {
  let num = [];
  const result = venuesArr.reduce((acc, curr, index) => {
    if (index < venuesArr.length - 1 && curr.name === venuesArr[index + 1].name) {
      num.push(curr.number);
      acc.push({
        name: curr.name,
        number: num,
      });
      return acc;
    }
    if (index && curr.name === venuesArr[index - 1].name) {
      num.push(curr.number);
      acc.push({
        name: curr.name,
        number: num,
      });
      num = [];
      return acc;
    }
    num = [];
    acc.push({
      name: curr.name,
      number: +curr.number ? [+curr.number] : [0],
    });
    return acc;
  }, []);
  return uniqBy(result, ({ name }) => name);
}

function venuesStringifyResult(venuesArr) {
  return venuesArr.reduce((acc, curr) => {
    if (isEmpty(curr.number) || curr.number.every((num) => num === 0)) {
      acc.push(curr.name);
      return acc;
    }
    if (curr.number.some((value, index, arr) => index <= 0 || +value === +arr[index - 1] + 1)) {
      if (curr.number[0] === curr.number[curr.number.length - 1])
        acc.push(`${curr.name} ${curr.number[0]}`);
      else acc.push(`${curr.name} ${curr.number[0]} - ${curr.number[curr.number.length - 1]}`);
      return acc;
    }

    const firstValue = curr.name;
    const filtered = curr.number.filter((value) => value !== 0);
    if (filtered.every((value, index, arr) => index <= 0 || +value === +arr[index - 1] + 1)) {
      acc.push(`${firstValue}\n${firstValue} ${filtered[0]} - ${filtered[filtered.length - 1]}`);
      return acc;
    }
    acc.push(`${firstValue} ${curr.number || ''}`);
    return acc;
  }, []);
}

function venuesStringify(numbersArr) {
  let result = [];
  let temp = [];
  numbersArr.forEach((number, index) => {
    let length = temp.length;
    if (length === 0 || temp[length - 1] === number - 1) temp.push(number);
    else {
      result.push(temp);
      temp = [number];
    }
  });

  result.push(temp);
  return result;
}

export default function venuesHandler(venuesArr, translations) {
  const numRegEx = /\d+/g;
  const result = venuesArr.reduce((acc, curr) => {
    if (curr.match(numRegEx)) {
      acc.push({
        name: getTranslationByKey(translations, curr.replace(numRegEx, '').trim()),
        number: +curr.match(numRegEx)[0],
      });
    } else {
      acc.push({
        name: getTranslationByKey(translations, curr.trim()),
        number: 0,
      });
    }
    return acc;
  }, []);

  const simplified = venuesSimplify(result);
  const results = [];
  simplified.forEach((venue) => {
    venuesStringify(venue.number).forEach((arr) => {
      results.push({
        name: venue.name,
        number: arr,
      });
    });
  });

  return venuesStringifyResult(results);
}
